// components/HeroPreview.jsx
import { FaPlay } from "react-icons/fa";
import { Link } from "react-router-dom";
import Footer from "./Footer";

export default function HeroPreview({ currentYear, content ,showPromo ,promo ,previewUrls}) {
  return (
    <div className="min-h-screen" style={{
      background: 'linear-gradient(110deg, #431F54 0%, #151226 60%, #17254A 100%)',
    }}>

      {/* <Navbar></Navbar> */}
      {content &&
        <>
          <div
            id="hero-section"
            className="relative h-[36rem] w-full sm:h-[70vh] lg:h-[90vh] "
          >
            {/* Background image */}
            <img
              src={previewUrls["content.hero.backgroundImage"] || content?.hero.backgroundImage}
              alt="Hero background"
              className="absolute top-0 left-0 h-full w-full object-cover z-0"
            />

            {/* Text container: relative + z-index above image */}
            <div className="relative  z-10 grid content-center justify-center h-full justify-items-center px-4">
              <div className="w-10/12 text-center sm:w-11/12 md:w-[40rem]">
                <h1
                  style={{
                    letterSpacing: "-0.05rem",
                    lineHeight: "1.125",
                    backgroundImage:
                      "linear-gradient(45deg, rgba(255, 255, 255, 0.412) 0%, #FFFFFF 67%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontFamily: "'Inter', sans-serif",
                  }}
                  className="mb-3 text-3xl font-semibold sm:text-4xl md:text-4xl lg:text-6xl"
                >
                  {content?.hero.title1}
                </h1>
                <h1 className="mb-3 text-3xl font-semibold text-orange-400 sm:text-4xl md:text-4xl lg:text-6xl">
                  {content?.hero.title2}
                </h1>
                <h1
                  style={{
                    letterSpacing: "-0.05rem",
                    lineHeight: "1.125",
                    backgroundImage:
                      "linear-gradient(45deg, rgba(255, 255, 255, 0.412) 0%, #FFFFFF 67%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: 500,
                    fontSize: "2em",
                  }}
                  className="my-10 text-2xl font-bold sm:text-2xl"
                >
                  {content?.hero.subtitle}
                </h1>

                <div className="flex w-full items-center justify-center">
                  <Link to={"/signin"}>
                    <button
                      style={{ background: "linear-gradient(to right, #20C9B5 ,#3E6A9E)" }}
                      className="flex items-center gap-3 justify-center rounded-full px-10 py-2 font-medium text-white transition-transform duration-500 ease-in-out transform hover:scale-110 sm:py-4 md:mt-0 md:pb-5 md:text-xl lg:w-full"
                    >
                      <FaPlay />
                      {content?.hero.ctaText}
                    </button>
                  </Link>
                </div>
              </div>
            </div>

          </div>
          {showPromo &&
            <section id="event-section" className="pt-16  text-white">
              <div className="max-w-5xl mx-auto px-6">
                <div className=" flex flex-col md:flex-row items-center gap-1 md:gap-12">

                  {/* Text Content */}
                  <div className="md:w-1/2">
                    <h2 className="text-3xl lg:text-4xl font-bold leading-tight mb-4 text-white/80  bg-clip-text">
                      {promo?.title}
                    </h2>
                    <p className="text-gray-300 text-lg mb-6">
                    {promo?.description}
                    </p>
                    <div className=" bg-gradient-to-r from-purple-600 via-pink-500 to-red-500 p-6 rounded-2xl shadow-xl text-center mb-4">
                      <p className="text-2xl lg:text-3xl  font-extrabold tracking-tight text-white mb-2">
                        🎉 <span className="text-3xl lg:text-4xl text-white/80 font-black align-end">-{promo?.discount}%</span>  {promo?.discountText}
                      </p>

                      <p className="text-sm uppercase tracking-widest text-white/90">
                        Utilisez le code promo ci-dessous
                      </p>
                      <div className="bg-black/40  text-white py-2 px-4 rounded-xl mt-3 inline-block text-2xl tracking-wide font-mono shadow-lg">
                        {promo?.promoCode}
                      </div>
                    </div>

                  </div>

                  {/* Image */}
                  <div className="md:w-1/2">
                    {/* Discount Highlight */}
                    <img
                      src={previewUrls["promo.image"] || promo?.image}
                      alt="Event"
                      className="w-full max-h-40rem h-full rounded-3xl  shadow-2xl border border-white/10"
                    />
                  </div>
                </div>
              </div>
            </section>
          }
          {/* Section 2 */}
          <section id="sections-section" >
            <div className="flex min-h-screen md:min-h-40rem lg:min-h-screen items-center justify-center mx-5">
              <div className="relative flex w-full max-w-[70rem] flex-col md:flex-row rounded-xl bg-black/20 bg-clip-border text-gray-200 shadow-md border-[0.01px] border-purple-200">
                <div className="relative m-0 md:w-2/5 shrink-0 overflow-hidden rounded-xl rounded-r-none bg-white bg-clip-border text-gray-700">
                  <img
                    src={previewUrls["content.section1.image"] || content?.section1.image}
                    alt="image"
                    className="h-full w-[full] object-cover"
                  />
                </div>
                <div className="p-6 flex flex-col justify-center ">
                  <h6 className="mb-4 block font-sans text-base font-semibold uppercase leading-relaxed tracking-normal text-orange-400 antialiased">
                    {content?.section1.badge}
                  </h6>
                  <h4 style={{
                    // textAlign: "center",
                    color: "#FFFFFF",
                    fontFamily: "'Inter', sans-serif",
                    letterSpacing: "-0.05rem",
                    width: "100%",
                    lineHeight: "1.125",
                    backgroundImage: "linear-gradient(45deg, rgba(255, 255, 255, 0.412) 0%, #FFFFFF 67%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                    className="mb-5 block font-sans text-xl lg:text-5xl font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased">
                    {content?.section1.title}
                  </h4>
                  <p className="mb-8 block text-sm lg:text-xl font-sans  font-normal leading-relaxed text-gray-400 antialiased">
                    {content?.section1.description}
                  </p>

                </div>
              </div>

            </div>

          </section>

          {/* Section 3 */}
          <section>
            <div>
              <div className="flex justify-center py-8">
                <div className="lg:flex lg:items-center lg:w-9/12">
                  <div>
                    <h1 style={{
                      // textAlign: "center",
                      color: "#FFFFFF",
                      fontFamily: "'Inter', sans-serif",
                      letterSpacing: "-0.05rem",
                      lineHeight: "1.125",
                      backgroundImage: "linear-gradient(45deg, rgba(255, 255, 255, 0.412) 0%, #FFFFFF 67%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }} className="mt-2 mb-6 mr-3 text-4xl font-semibold text-center text-white lg:mt-0 lg:text-left lg:ml-8 lg:text-5xl xl:text-5xl">
                      {content?.section2.title}
                    </h1>
                    <h1 className="m-4 text-center text-gray-400 font-normal lg:text-left lg:ml-8 lg:text-xl lg:w-9/12">
                      {content?.section2.description}
                    </h1>
                  </div>
                  <div className="flex justify-center">
                    <img style={{ borderRadius: "20px" }} className="max-w-[50%] lg:max-w-[100%]" src={previewUrls["content.section2.image"] || content?.section2.image} />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Section 4 */}
          <section >
            <div className="py-10  w-fill h-fit">
              <img className="object-cover w-fill" src={previewUrls["content.section3.image"] || content?.section3.image} />
            </div>
          </section>

          {/* Section 5 */}
          <section>
            <div>
              <div className="flex justify-center px-5 md:py-8">
                <div className="flex flex-col-reverse md:flex-row md:items-center lg:w-9/12">
                  <div className="flex justify-center">
                    <img style={{ borderRadius: "20px" }} className="max-w-[50%] lg:max-w-[100%]" src={previewUrls["content.section4.image"] || content?.section4.image} />
                  </div>
                  <div>
                    <h1 style={{
                      // textAlign: "center",
                      color: "#FFFFFF",
                      fontFamily: "'Inter', sans-serif",
                      letterSpacing: "-0.05rem",
                      lineHeight: "1.125",
                      backgroundImage: "linear-gradient(45deg, rgba(255, 255, 255, 0.412) 0%, #FFFFFF 67%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }} className="mt-4 mb-6 text-2xl sm:text-3xl md:text-4xl font-semibold text-center text-white md:mt-0 md:text-left md:ml-8 ">
                      {content?.section4.title}
                    </h1>
                    <h1 className="m-4 text-center text-gray-400 font-normal md:text-left md:ml-8 md:text-xl lg:w-9/12">
                      {content?.section4.description}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Section 6 */}
          <section>
            <div className="flex min-h-screen items-center justify-center mx-5">
              <div className="relative flex w-full max-w-[70rem] flex-col md:flex-row rounded-xl bg-black/20 bg-clip-border text-gray-200 shadow-md border-[0.01px] border-purple-200">

                <div className="p-6 lg:p-12 flex flex-col justify-center ">
                  <h6 className="mb-4 block font-sans text-base font-semibold uppercase leading-relaxed tracking-normal text-orange-400 antialiased">
                    {content?.section5.badge}
                  </h6>
                  <h4 style={{
                    // textAlign: "center",
                    color: "#FFFFFF",
                    fontFamily: "'Inter', sans-serif",
                    letterSpacing: "-0.05rem",
                    width: "100%",
                    lineHeight: "1.125",
                    backgroundImage: "linear-gradient(45deg, rgba(255, 255, 255, 0.412) 0%, #FFFFFF 67%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                    className="mb-5 block font-sans text-xl lg:text-5xl font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased">
                    {content?.section5.title}
                  </h4>
                  <p className="mb-8 block text-sm lg:text-xl font-sans  font-normal leading-relaxed text-gray-400 antialiased">
                    {content?.section5.description}
                  </p>

                </div>
                <div className="h-[450px] relative m-0 md:w-1.5/5 shrink-0 overflow-hidden rounded-xl rounded-l-none bg-white bg-clip-border text-gray-700">
                  <img
                    src={previewUrls["content.section5.image"] || content?.section5.image}
                    alt="image"
                    className="h-full w-full object-cover"
                  />
                </div>
              </div>

            </div>

          </section>

          {/* Section 7 */}
          <section >
            <div className="py-10 w-fill h-fit">
              <img className="object-cover w-fill" src={previewUrls["content?.section6.image"] || content?.section6.image} />
            </div>
          </section>

          {/* Section 8 */}
          <section >
            <div className=" px-5 py-10 text-center flex justify-center">
              <h4 style={{
                // textAlign: "center",
                color: "#FFFFFF",
                fontFamily: "'Inter', sans-serif",
                letterSpacing: "-0.05rem",
                lineHeight: "1.3",
                backgroundImage: "linear-gradient(45deg, rgba(255, 255, 255, 0.412) 10%, #FFFFFF 67%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
                className="w-[100%] md:w-[90%] mb-5 block font-sans text-3xl md:text-4xl font-medium leading-snug tracking-normal text-blue-gray-900 antialiased">
                {content?.section7.mainText}


              </h4>
            </div>
          </section>

          <div className="w-full flex justify-center">
            <hr className=" h-0.5 border-t-0 w-[80%] md:w-[60%]  bg-neutral-100 dark:bg-white/10"></hr>

          </div>

          {/* Section 9 */}
          <section id="features-section" >
            <div className=" px-4 mx-auto w-[90%] sm:py-16 lg:px-6">
              <div className="px-5  text-center flex justify-center">
                <h4 style={{
                  // textAlign: "center",
                  color: "#FFFFFF",
                  fontFamily: "'Inter', sans-serif",
                  letterSpacing: "-0.05rem",
                  lineHeight: "1.3",
                  backgroundImage: "linear-gradient(45deg, rgba(255, 255, 255, 0.412) 10%, #FFFFFF 67%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
                  className="w-[100%] mb-10 block font-sans text-3xl md:text-4xl font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased">
                  {content?.features.title}

                </h4>
              </div>
              <div className="w-full my-5 space-y-8 md:grid md:grid-cols-2 lg:grid-cols-4 md:gap-14 md:space-y-0">
                {content?.features.items.map((item, index) => (
                  <div key={index} className="text-center">
                    <h4
                      style={{
                        color: "#FFFFFF",
                        fontFamily: "'Inter', sans-serif",
                        letterSpacing: "-0.05rem",
                        lineHeight: "1.3",
                        backgroundImage:
                          "linear-gradient(45deg, rgba(255, 255, 255, 0.412) 10%, #FFFFFF 67%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                      }}
                      className="w-full block font-sans text-xl md:text-xl font-medium leading-snug tracking-normal text-blue-gray-900 antialiased"
                    >
                      {item}
                    </h4>
                  </div>
                ))}
              </div>

            </div>
          </section>

          {/* Section 10 */}
          <section className="px-5 w-full flex items-center flex-col gap-5 md:gap-10 justify-center">
            <div className="px-5 w-fit flex items-center flex-col gap-5 md:gap-10 justify-center">
              <div className="w-full ">
                <Link to={"/signup"}>
                  <button
                    style={{
                      background: "linear-gradient(to right, #20C9B5 ,#3E6A9E)",
                    }}
                    className=" w-[100%] px-10 py-2 mt-3 font-medium text-white rounded-full sm:py-4 md:mt-0 md:pb-5 md:text-xl flex items-center gap-3 justify-center 
                  transition-transform duration-500 ease-in-out transform hover:scale-110"
                  >
                    <FaPlay />
                    {content?.hero.ctaText}
                  </button>
                </Link>
              </div>


            </div>
          </section>

          <hr className="my-12 h-0.5 border-t-0 bg-neutral-100 dark:bg-white/10"></hr>

          {/* Footer */}
          <Footer id="footer-section" data={content?.footer} currentYear={currentYear}></Footer>
        </>}

    </div>
  );
}
